<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Listado de Altas
            br
            router-link.a.button.is-primary.is-rounded.is-medium(to="/Inventario/AltaNueva") Nueva
            br
        .columns.is-centered(v-show="hayDatos")
          .column.is-8.is-offset-2
            table#tbExistencias.table.is-striped
              thead
                tr
                  th idAlta
                  th Solicita
                  th Ubicación
                  th Área
                  th Fecha Alta
              tbody
                tr(v-for="(data, index) in altas" :key="data.id")
                  td 
                    a.button.is-primary(@click="irAltaDetalle(data.id)") {{ data.id }} 
                  td {{ data.solicita }}
                  td 📌 {{ data.ubicacion }}
                  td {{ data.area | categoriaToHtml }}
                  td {{ data.fechaReg }}
        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos.
</template>

<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import { mapState } from 'vuex'

export default {
  name: 'Altas',
  components: { Loader, NavBarInventario },
  data () {
    return {
      isLoading: true,
      altas: [],
      hayDatos: false,
      tipos: []
    }
  },
  methods: {
    obtenerTipos () {
      InventarioServices.getTipos()
        .then(res => {
          console.log(res)
          if (res.length > 0) {
              this.tipos = res
          } else {
            console.log('No hay Tipos')
          }
        })

      setTimeout(() => {
        this.obtenerDataAltas()
      }, 250)
    },
    obtenerDataAltas () {
      InventarioServices.getAltas()
        .then(res => {
          console.log(res)
          if (res.length > 0) {
            console.log(this.userLogin)

            if (this.userLogin.categoria === 0) {
              this.altas = res
            } else {
              this.altas = res.filter(alta => alta.id_usuario === this.userLogin.id)
            }
            let numAltas = this.altas.length
            console.log(numAltas)
            if (numAltas == 0) {
              this.hayDatos = false
            } else {
              this.hayDatos = true
            }
            this.isLoading = false
          } else {
            this.isLoading = false
            this.hayDatos = false
          }
        })
    },
    irAltaDetalle (id) {
      setTimeout(() => {
        this.$router.push({ path: `/Inventario/Alta/Detalle/${id}` })
      }, 250)
    },
  },
  created () {
    this.obtenerTipos()
  },
  computed: {
    ...mapState(['userLogin'])
  }
}
</script>

<style lang="css" scoped>

</style>





// WEBPACK FOOTER //
// src/components/inventario_Componentes/Altas.vue